// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"UK-z","loadingMedia":"VK-z","reviewsImagesAndVideos":"WK-z","limitHeight":"XK-z"};